// Core
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';

// Assets
import { apiService } from 'services/ApiService';

// Components
import RequestLogDetailsContent from './components/RequestLogDetailsContent';

const RequestLogDetails = () => {
  const { id } = useParams();

  const { data: requestLog, isLoading, isError } = useQuery({
    queryKey: ['request-log', id],
    enabled: !!id,
    refetchOnWindowFocus: false,
    refetchOnError: false,
    queryFn: async () => {
      return (await apiService.getRequestLog({ id })).data;
    },
  });


  return (isError ?
    <div>Not Found</div> : isLoading ?
    <div>Loading...</div> :
        <RequestLogDetailsContent requestLog={requestLog} />
  );
};

export default RequestLogDetails;